import { FC } from 'react';
import { Modal } from '@dynamika-shared/ui/Modal/Modal';

export type Procedure =
  | 'pdf'
  | 'release'
  | 'email'
  | 'send'
  | 'reject'
  | 'release_and_email'
  | 'escalate';

type ProcedureConfirmation = Exclude<Procedure, 'pdf'>;

type ReportProcedureConfirmationModalProps = {
  darkMode?: boolean;
  patientCode?: string;
  procedure: Procedure;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  open?: boolean;
  okText?: string;
  cancelText?: string;
};

const textMap: Record<ProcedureConfirmation, string> = {
  release:
    'Are you sure you want to release this report? Once released, the report will be visible on the platform and accessible to authorized users?',
  email: '',
  release_and_email: '',
  send: '',
  reject:
    'Are you sure you want to reject this report? Once rejected, the report will not be visible or accessible anywhere on the platform?',
  escalate: '',
};

const titleMap: Record<ProcedureConfirmation, string> = {
  release: 'Release Report',
  email: 'Email Report',
  release_and_email: 'Release and Email Report',
  send: 'Send Report',
  reject: 'Reject Report',
  escalate: 'Escalate Report',
};

export const ReportProcedureConfirmationModal: FC<
  ReportProcedureConfirmationModalProps
> = ({
  darkMode,
  onConfirm,
  onCancel,
  procedure,
  open,
  patientCode = '',
  okText = 'Yes',
  cancelText = 'No',
}) => {

  const confirmationText = textMap[procedure as ProcedureConfirmation] || '';
  const title = titleMap[procedure as ProcedureConfirmation] || '';
  const titleText = title && patientCode ? `${title} for ${patientCode}` : '';
  return (
    <Modal
      data-testid='ReportConfirmation'
      width={464}
      darkMode={darkMode}
      onCancel={onCancel}
      onOk={onConfirm}
      classNames={{
        header: '[&_h2]:!text-left [&_h2]:!font-medium !mb-[3.2rem]',
      }}
      okProps={{ htmlType: 'button' }}
      cancelClassName={'w-[18rem] text-black'}
      okClassName={'w-[18rem]'}
      okText={okText}
      cancelText={cancelText}
      maskClosable={false}
      open={open}
      title={titleText}
    >
      <div className='text-[16px] text-center'>
        <div>{`${confirmationText}`}</div>
      </div>
    </Modal>
  );
};
